import '../helper/global-jquery';
import LazyLoad from 'vanilla-lazyload';

const lazyLoadInstance = new LazyLoad({
  callback_loading: (img) => {
    //nothing TODO
  },
  callback_enter: (el) => {
    let $element = $(el);
    if ($element[0].nodeName === 'PICTURE' && $element.find('source').length > 0) {
      $.each($element.find('source'), function () {
        var $this = $(this);
        $this.attr('srcset', $this.attr('data-srcset')).removeAttr('data-srcset');
      });
      $.each($element.find('img'), function () {
        var $this = $(this);
        $this.attr('src', $this.attr('data-src')).removeAttr('data-src');
      });
      $element.removeClass('lazy').removeClass('entered').addClass('loaded');
    }
  },
  callback_loaded: (el) => {
    let $element = $(el);
    $element.removeClass('lazy').removeClass('entered').addClass('loaded');
  },
});
